import { gql } from '@apollo/client'

// The exact set of post fields a PostCard / PostMeta needs. Shared by every
// query that feeds a card (the channels timeline, a single channel's posts,
// and the post detail screen) so the selection — and the generated type used
// to type PostCard — lives in one place.
export const POST_CARD_FIELDS = gql`
  fragment PostCardFields on Post {
    id
    text
    publishedAt
    editedAt
    linkUrl
    linkTitle
    photos {
      id
      url
    }
    author {
      id
      fullName
    }
    channel {
      id
      name
      image
      updatedAt
      publishAuthorName
    }
  }
`
